import React from 'react'
import { Avatar, formatDateTime } from '../../common/Functions'
import { capitalizeFirstLetter } from '../../utils/common'

const UserTransactionTable = ({data = [], filteredData, setSelectedHost}) => {
    console.log("TRANSACTIONS LIST --> ", filteredData)
  return (
    <div>
        <div className="bg-white shadow rounded-2xl overflow-hidden">
                    <table className="w-full text-center">
                        <thead className="bg-gray-200 text-m text-black">
                            <tr>
                                <th className="p-4 text-left font-normal">Event Id</th>
                                <th className="p-4 text-left font-normal">Date & Time</th>
                                <th className="p-4 text-left font-normal">Host Name</th>
                                <th className="p-4 text-left font-normal">Attendee Name</th>
                                <th className="p-4 text-left font-normal">Amount</th>
                                <th className="p-4 text-left font-normal">Commission</th>
                                <th className="p-4 text-left font-normal">Transactions Id</th>
                                <th className="p-4 text-left font-normal">Status</th>
                            </tr>
                        </thead>

                        {/* Table body */}
                        <tbody>
                            {filteredData.map((host, index) => (
                                <tr key={host._id} className="border-t hover:bg-gray-50 cursor-pointer" >
                                    <td className="p-5 text-left text-[#4C4C4C] font-normal text-sm">#{host.eventId.slice(-5)}</td>
                                    <td className="p-5 text-left font-normal text-[#4C4C4C] text-sm">{formatDateTime(host.createdAt) || "--"}</td>
                                    {/* <-- Important: LEFT aligned cell with flex row for avatar + name */}
                                    {/* <td className="p-5text-left" onClick={() => setSelectedHost(host)}>
                                        <div className="flex items-center gap-3">
                                            {
                                                host.host.image !== "" ?
                                                <Avatar name={host.host.name} image={host.host.image} size={32} />  : 
                                                <div className="ml-3 w-8 h-8 flex items-center justify-center bg-[#FFEFEF] rounded-full text-sm font-semibold">
                                                    {host.host.name.slice(0,1)}
                                                </div>
                                            }

                                            <div className="font-normal text-[#4C4C4C] text-sm">
                                                {host.host.name}
                                            </div>
                                        </div>
                                    </td> */}
                                    <td className="p-4" onClick={() => setSelectedHost(host)}>
                                        <div className="flex items-center gap-3">
                                        {/* Avatar: circle, fixed size, object-cover if image */}

                                        <Avatar name={host.host.name} image={host.host.image} size={32}/>


                                        {/* Name text */}
                                        <div className="text-sm font-normal text-[#4C4C4C]">
                                            {capitalizeFirstLetter(host.host.name)}
                                        </div>
                                        </div>
                                    </td>

                                    <td className="p-5 text-left font-normal text-[#4C4C4C] text-sm">{capitalizeFirstLetter(host.userId.name)}</td>

                                    <td className="p-5 text-left font-normal text-[#4C4C4C] text-sm">${String(host.transferAmount || 0).padStart(1, "0")}</td>
                                    <td className="p-5 text-left font-normal text-[#4C4C4C] text-sm">${String(Math.round((host.amount - host.transferAmount)*100)/100 || 0).padStart(2, "0")}</td>

                                    {/* <td className="p-5 text-left font-normal text-[#4C4C4C] text-sm">
                                        {host.commission}%
                                    </td> */}
                                    <td className="p-5 text-left font-normal text-[#4C4C4C] text-sm">
                                        #{host.transaction_id}
                                    </td>
                                    <td className="p-5 text-left font-normal text-[#4C4C4C] text-sm">
                                        {capitalizeFirstLetter(host.status)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {filteredData.length === 0 && (
                        <p className="text-center py-10 text-gray-500">
                            No results found
                        </p>
                    )}
                </div>
    </div>
  )
}

export default UserTransactionTable